import React, {useContext} from "react";
import {Container, Tab, Nav, Col, Button, Row} from "react-bootstrap";
import {SubmitButton} from "../forms";
import HourTariffs from "./HourTariffs";
import CalulationSettings from "./start/CalulationSettings";
import GeneralSettings from "./algemeen/GeneralSettings";
import InputHoursTable from "./calculatie/InputHoursTable";
import Products from "./products/Products";
import {useFormikContext} from "formik";
import {Print} from "@material-ui/icons";
import ProjectContext from "../../utils/context";
import {useNavigate} from "react-router-dom";


const Overview = () => {
    // TODO: add prompt when dirty and not saved
    const formikObject = useFormikContext() // .dirty is true when form is used
    const {handleSubmit} = useFormikContext();
    const {project} = useContext(ProjectContext)
    let navigate = useNavigate();

    const saveOnClick = () => {
        if (formikObject.dirty) {
            //er zijn changes
            console.log("dirty")
            handleSubmit();
        } else {
            //er zijn geen changes
            console.log("not dirty")
        }
    }

    const navigateToTotalenPrint = () => {
        navigate(`/${project.service_form_id}/totalenprint`)
    }

    return <Container>
        <div className={"tab"}>
            <Tab.Container defaultActiveKey="Start">
                <Nav variant="tabs">
                    <Nav.Item onClick={saveOnClick} >
                        <Nav.Link eventKey="Start">Start</Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={saveOnClick}>
                        <Nav.Link eventKey="Algemeen">Algemeen</Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={saveOnClick}>
                        <Nav.Link eventKey="Uurtarieven">Uurtarieven</Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={saveOnClick}>
                        <Nav.Link eventKey="Calculatie">Calculatie</Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={saveOnClick}>
                        <Nav.Link eventKey="Artikelen">Artikelen</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>

                    <Tab.Pane eventKey="Start" title="Start">
                        <CalulationSettings/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Algemeen" title="Algemeen">
                        <GeneralSettings/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Uurtarieven" title="Uurtarieven">
                        <HourTariffs/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Calculatie" title="Calculatie">
                        <Row>
                            <Col lg={10}></Col>
                            <Col lg={2}>
                                <Button className={"float-right"} variant={"primary"} onClick={navigateToTotalenPrint}>
                                    <Print />
                                </Button>
                            </Col>
                        </Row>
                        <InputHoursTable/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Artikelen" title="Artikelen">
                        <Products/>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
            <div style={{position: "fixed", top: "10%", right: "2%"}}>
                <SubmitButton title={"Opslaan"}/>
            </div>
        </div>

    </Container>


}

export default Overview;